import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/** Gate for /platform/* routes — only platform admins may enter.
 *  Also forces the BlackScott platform palette (slate + gold) so the UI
 *  reflects the platform context independently of the session's
 *  active_tenant_id. */
export default function PlatformRoute({ children }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  React.useEffect(() => {
    const root = document.documentElement;
    const prevPrimary = root.style.getPropertyValue("--brand-primary");
    const prevAccent = root.style.getPropertyValue("--brand-accent");
    root.style.setProperty("--brand-primary", "#0f172a");
    root.style.setProperty("--brand-accent", "#D9B14A");
    root.dataset.platform = "1";
    return () => {
      if (prevPrimary) root.style.setProperty("--brand-primary", prevPrimary);
      if (prevAccent) root.style.setProperty("--brand-accent", prevAccent);
      delete root.dataset.platform;
    };
  }, []);

  if (isLoading) return null;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!user.is_platform_admin) return <Navigate to="/" replace />;
  return children;
}
